export default () => ({
  drawer: null,
  color: 'success',
  image: 'http://rekryt.ru/files/sidebar-2.32103624.jpg'
})
